<ng-container>
  <div class="job-orders" *ngIf="localJobOrderDataStates.length; else empty">
    <table
      matSort
      mat-table
      [dataSource]="localJobOrderDataStates"
      (matSortChange)="sortData($event)"
    >
      'selection', 'fileName', 'operation', 'machineName', 'startDate',
      <ng-container matColumnDef="selection">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox (change)="$event ? masterRowsToggle() : null" [checked]="masterAllSelected">
          </mat-checkbox>
        </th>

        <td mat-cell *matCellDef="let dataState">
          <mat-checkbox
            class="example-margin"
            [checked]="dataState.isSelected"
            (change)="onDataStateCheckChanged(dataState)"
          ></mat-checkbox
          ><!-- radio button -->
        </td>
      </ng-container>

      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <span class="item-head">Description</span>
        </th>
        <td mat-cell *matCellDef="let dataState">
          <input
            type="text"
            class="item"
            value="{{ dataState.description }}"
            disabled
          />
        </td>
      </ng-container>

      <ng-container matColumnDef="operation">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <span class="item-head">Operation</span>
        </th>
        <td mat-cell *matCellDef="let dataState">
          <input
            type="text"
            class="item"
            value="{{ dataState.operation }}"
            disabled
          />
        </td>
      </ng-container>

      <ng-container matColumnDef="machineName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <span class="item-head">Machine name</span>
        </th>
        <td mat-cell *matCellDef="let dataState">
          <input
            type="text"
            class="item"
            value="{{ dataState.machineName }}"
            disabled
          />
        </td>
      </ng-container>

      <ng-container matColumnDef="startDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <span class="item-head">Start datetime</span>
        </th>
        <td mat-cell *matCellDef="let dataState">
          <input
            type="text"
            class="item"
            value="{{ dataState.startDate }}"
            disabled
          />
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
      <tr
        mat-row
        *matRowDef="let myRowData; columns: columnsToDisplay"
        [ngClass]="{
          unchanged: myRowData.selectionState == 'UNCHANGED',
          added: myRowData.selectionState == 'ADDED',
          removed: myRowData.selectionState == 'REMOVED'
        }"
      ></tr>
    </table>
  </div>
</ng-container>

<ng-template #empty>
  <div class="container-empty">
    <span>No data state found</span>
  </div>
</ng-template>
